import { posAxiosClient } from '@kinderlabs-pos/apis/axios';
import { DdiziType } from '@kinderlabs-pos/shared-data-type';

export const getDdiziListInOrderAsync =
	(rootUrl: string) =>
	async ({ orderId }: { orderId: string }) =>
		(await posAxiosClient.get<DdiziType[]>(`${rootUrl}/ddizi/order/${orderId}/list`)).data;
